import React, { Component } from 'react'
// import PageBuilderAddElements from './PageBuilderAddElements'
// import PageBuilderAddElements2 from './PageBuilderAddElements2'
// import PageBuilderHeader from './PageBuilderHeader'
import PageBuilderMain from './PageBuilderMain'
import { formBuilderGroups, FormBuilderObjects } from '../variables/formBuilderData'
import { widgetsList, widgetsGroups } from '../variables/widgetsList'
import inputComponents from '../components/inputs/inputComponents'
import WidgetComponents from '../components/widgets/WidgetComponents'
// import ButtonAnimated from '../components/buttons/ButtonAnimated'
import HttpServices from '../utils/Http.services'
// import Modal from '../components/Modal'
// import { translate } from '../utils/useful'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import importedIcons from '../components/inputs/icons'
import { conditionToFilterConditionGroup } from '../utils/conditionFilterFunctions'
import MenuToolbar from '../components/header/MenuToolbar'
import formulaColumnsParser from '../utils/formulaColumnsParser'
import { setObject } from '../utils/useful'
// import { FormBuilderObjects } from '../variables/formBuilderData';

class PageViewer extends Component {
    state = {
        type: 'dashboard',
        componentsInfo: {
            form: { object: FormBuilderObjects, groups: formBuilderGroups, components: inputComponents },
            dashboard: { object: widgetsList, groups: widgetsGroups, components: WidgetComponents },
        },
        // showPage:true,

    }

    componentDidMount() {
        this.init(true)

        // console.log("PageViewer componentDidMount")

        // if (this.props.setHeader) {
        //     this.props.setHeader({
        //         // 'toolbar': null,
        //         'showToolbar': false,
        //         topHeaderComponent: this.topHeaderComponent,
        //         headerIdentityComponent: this.headerIdentityComponent,
        //         backAction: () => { this.props.changePage(''); console.log('backkkkkkkkkkkkkkkk') }

        //     })
        // }
    }
    componentDidUpdate(prevProps) {


        // console.log(this.props.windowData)
        // console.log(this.props.baseUrl)

        if (Array.isArray(this.props.windowData?.path)) {
            if (this.props.windowData?.path[this.props.baseUrl?.length] != prevProps.windowData?.path[this.props.baseUrl?.length]) {
                console.log("TP1", this.props.windowData?.path, prevProps.windowData)
                this.init(true)
            }
        }
        if (this.props.page) {
            if ((this.props.page ? JSON.stringify(this.props.page?._id) : null) != (this.state.page ? JSON.stringify(this.state.page?._id) : null)) {

                // console.log("TP2", this.props.page, this.state.page)
                // console.log('this.props.page', this.props.page, this.state.page)
                this.init()
            }
        }
    }
    // init = () => {
    //     let _id = this.props.windowData?.path[this.props.baseUrl?.length]
    //     console.log('get Page', this.props.applet)
    //     // console.log(_id)
    //     if (_id != "new" && _id != null) {

    //         // GET PAGE
    //         HttpServices.request('getFrame', { _id: _id }, (fetchResult, fetchError) => {
    //             console.log('fethcresult1-', fetchResult.info)
    //             this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name }, () => {

    //                 // this.props.setHeader("dummy",1)
    //             })
    //         })
    //     }
    //     else if (this.props.applet?.page) {
    //         HttpServices.request('getFrame', { _id: this.props.applet.page?._id }, (fetchResult, fetchError) => {
    //             console.log('fethcresult1-', fetchResult.info)
    //             this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name }, () => {
    //                 if (this.props.setHeader) {
    //                     this.props.setHeader("dummy", 1)
    //                 }
    //             })
    //         })
    //         // this.setState({ _id: this.props.applet?.page._id, initData: this.props.applet?.page.page, name: this.props.applet?.page.name }, () => {
    //         //     this.props.setHeader("dummy", 1)
    //         //     console.log('this.props.applet?.page', this.props.applet?.page)
    //         // })
    //     }
    // }
    init(force) {

        // console.log("INIT")
        // this.setState({ showPage: false })
        // console.log('init')
        // TO DO: CHECK IF THE FUNCTION IS LOADING MORE THAN ONCE
        // console.log("PageViewer init", force, this.props.page)

        if (this.props.page || force) {

            // console.log('initdwqd',this.props.windowData?.path[this.props.baseUrl?.length])
            this.setState({ view: false, params: [], page: this.props.page ? JSON.parse(JSON.stringify(this.props.page)) : null }, () => {
                this.setState({ view: true }, () => {


                    let _id = this.props.windowData?.path[this.props.baseUrl?.length]



                    if (!_id && this.props.page) {
                        _id = this.props.page?._id
                    }
                    //  console.log('get Page', this.props.windowData?.path,this.props.baseUrl,_id, this.props.page?._id)

                    if (_id != "new" && _id != null) {

                        // console.log("getFrame",_id)
                        HttpServices.request('getFrame', { _id: _id }, (fetchResult, fetchError) => {



                            // console.log(fetchResult, fetchError)
                            if (fetchError || !fetchResult || !fetchResult.info) {
                                return
                            }

                            this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name, page: fetchResult?.info }, () => {
                                // if (this.props.setHeader) {

                                //     this.props.setHeader("dummy", 1)
                                // }
                                // console.log(fetchResult.info?.menu)

                                // if (this.props.setHeader) {

                                //     this.props.setHeader({
                                //         'toolbar': this.toolbarView,
                                //         'showToolbar': fetchResult.info?.menu,
                                //         title: fetchResult.info.name
                                //         // topHeaderComponent: this.topHeaderComponent,
                                //         // headerIdentityComponent: this.ViewHeaderIdentityComponent,
                                //         // backAction: () => this.props.changePage('pages')
                                //     })

                                // }


                                this.setWindowParams(fetchResult?.info)

                            })
                            if (fetchResult?.info?.config?.fetches) {
                                this.getSingleContent(fetchResult?.info)
                            } else {
                                this.setState({ showPage: true })
                            }
                        })
                    } else if (this.props.applet?.page) {

                        HttpServices.request('getFrame', { _id: this.props.applet.page?._id }, (fetchResult, fetchError) => {

                            if (fetchError || !fetchResult || !fetchResult.info) {
                                return
                            }

                            console.log(fetchResult, fetchError)
                            this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name, page: fetchResult?.info }, () => {
                                // if (this.props.setHeader) {

                                //     this.props.setHeader("dummy", 1)
                                // }

                                this.setWindowParams(fetchResult?.info)

                            })
                            // console.log('fetchResult?.info', fetchResult)

                            if (fetchResult?.info?.config?.fetches) {
                                this.getSingleContent(fetchResult?.info)
                            } else {
                                this.setState({ showPage: true })
                            }
                        })
                        //         HttpServices.request('getFrame', { _id: this.props.applet.page?._id }, (fetchResult, fetchError) => {
                        //             console.log('fethcresult1-', fetchResult.info)
                        //             this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name }, () => {
                        //                 if (this.props.setHeader) {
                        //                     this.props.setHeader("dummy", 1)
                        //                 }
                        //             })
                        //         })
                        //         // this.setState({ _id: this.props.applet?.page._id, initData: this.props.applet?.page.page, name: this.props.applet?.page.name }, () => {
                        //         //     this.props.setHeader("dummy", 1)
                        //         //     console.log('this.props.applet?.page', this.props.applet?.page)
                        //         // })
                    } else if (this.props.page) {
                        // console.log('ondashboardhere', this.props.page)
                        this.setState({ _id: _id, initData: this.props.page.page, name: this.props.page.name, page: this.props.page }, () => {
                            // if (this.props.setHeader) {

                            //     this.props.setHeader("dummy", 1)
                            // }
                            this.setWindowParams(this.props.page)

                        })

                        if (this.props.page?.config?.fetches) {
                            this.getSingleContent(this.props.page)
                        } else {
                            this.setState({ showPage: true })
                        }

                    }
                    // if (this.props.setHeader) {
                    //     this.props.setHeader({
                    //         'toolbar': null,
                    //         'showToolbar': false,
                    //         topHeaderComponent: this.topHeaderComponent,
                    //         headerIdentityComponent: this.headerIdentityComponent,
                    //         backAction: () => this.props.changePage(['settings', 'pages'])
                    //     })
                    // }

                })
            })

            this.fetchRelationsInfo()

        }


    }



    fetchRelationsInfo = (cb) => {

        // console.log("fetchRelationsInfo")

        let body = { appletHub: this.props.variables?.appletHub }
        // this.setState({ isLoadingList: true })

        // console.log(body)
        if (body.appletHub) {
            HttpServices.request('getRelationsFields', body, (fetchResult, fetchError) => {

                // this.setState({ isLoadingList: false })
                // console.log(fetchResult, fetchError)
                if (fetchError) {
                    return
                }

                // cb(fetchResult.info)
                let param = { label: "{{lang}}Relation info", value: 'relation', fields: fetchResult.info, info: {}, type: 'relation', hidden: true, }
                let params = this.state.params ?? []
                params.push(param)


            })
        }

    }

    // functionsHandler = (type, name, data, extra) => {
    //     if (this[name]) {
    //         this[name](data, extra)
    //     }
    // }






    setWindowParams = (info) => {

        let params = this.state.params ?? []
        let page = this.state.page

        // console.log("aaa", this.props.windowData)

        // console.log("bbb", info?.config)

        let windowPath = this.props.windowData?.path
        let windowParams = this.props.windowData?.params ?? {}

        // console.log(this.props.windowData)


        // let _id = this.props.windowData?.path[this.props.baseUrl?.length + 1]
        // let fetchInfo = info?.config?.fetches



        for (let i = 0; i < params.length; i++) {
            const param = params[i];
            if (param.type == 'window') {
                params.splice(i, 1)
                break
            }
        }

        if (page?.config?.params && page?.config?.params.length > 0) {

            let myParams = { label: "{{lang}}Window url", value: 'window', fields: [], info: {}, type: 'window' }

            for (let i = 0; i < page?.config?.params.length; i++) {
                const param = page?.config?.params[i];

                myParams.fields.push({ key: param.id, type: 'TextInput', information: { label: param.name, type: param.type } })
                // let myParam = { label: fetchInfo.name, value: '', fields: fetchResult.frame?.fields, info: fetchResult.info }

                // console.log(param)
                if (param.type == 'path') {

                    // console.log(this.props.baseUrl)
                    myParams.info[param.id] = windowPath[this.props.baseUrl?.length + 1 + i]
                }

                if (param.type == 'query') {
                    // console.log(param, param.id, param.name)
                    myParams.info[param.id] = windowParams[param.name]
                }
            }

            // console.log(JSON.parse(JSON.stringify(myParams)))
            params.splice(0, 0, myParams)
        }


        this.setState({ params }, () => { })
    }


    getSingleContent(info) {


        // console.log("getSingleContent")
        // let _id = this.props.windowData?.path[this.props.baseUrl?.length + 1]
        let fetches = info?.config?.fetches

        let params = this.state.params ?? []

        // console.log("params",params)

        // for (let i = params.length - 1; i >= 0; i--) {
        //     const element = params[i]
        //     let found = false
        //     for (let j = 0; j < params.length; j++) {
        //         const mParam = params[j];
        //         if (element.value == mParam.value) {
        //             found = true
        //         }
        //     }

        //     if (found) {
        //         params.splice(i, 1)
        //     }
        //     // console.log("element",element)
        //     // if (element.type == 'fetch') {
        //     //     params.splice(i, 1)
        //     // }
        // }

        // console.log(JSON.parse(JSON.stringify(params)))

        if (Array.isArray(fetches) && fetches.length > 0) {


            // console.log("body1", fetchInfo.api)

            let fullData = {}


            let promises = []
            let fetchedData = []

            // console.log(fetches)

            fetches.reverse().forEach(fetchInfo => {

                // console.log(fetchInfo.api)

                promises.push(new Promise((resolve) => {

                    if (!this.props.editMode && fetchInfo.api) {

                        // console.log(fetchInfo)

                        let body = {}

                        if (!fetchInfo.filter || !fetchInfo.filter.root) {
                            return
                        }

                        // console.log(fetchInfo.filter.root,JSON.parse(JSON.stringify(params)))
                        conditionToFilterConditionGroup(fetchInfo.filter.root, params, {}, (condRes) => {

                            // console.log("condRes", condRes)
                            let filter = condRes

                            body.filter = filter
                            body.frames = fetchInfo.frames

                            if (fetchInfo.x_axis) {
                                body.x_axis = fetchInfo.x_axis
                            }

                            if (fetchInfo.fields) {
                                body.fields = fetchInfo.fields
                            }

                            body.type = 'table'
                            body.params = params

                            // console.log("body1", fetchInfo.api, body)
                            HttpServices.request(fetchInfo.api, body, (fetchResult, fetchError) => {
                                // console.log(fetchResult, fetchError)


                                if (fetchError) {
                                    resolve()
                                    return
                                }


                                // console.log(fetchResult)
                                let fInfo = fetchInfo
                                fInfo.info = fetchResult.info
                                fInfo.frame = fetchResult.frame
                                let frames = fetchResult.frames
                                let allFields = []

                                let fields = fetchResult?.frame?.fields ?? []

                                if (Array.isArray(frames) && Array.isArray(fetchInfo.fields?.choosen)) {
                                    for (let f = 0; f < frames.length; f++) {
                                        const frame = frames[f];
                                        if (Array.isArray(frame.fields)) {
                                            for (let i = 0; i < frame.fields.length; i++) {
                                                const field = frame.fields[i];
                                                allFields.push(field)
                                            }
                                        }

                                    }

                                    if (Array.isArray(fetchInfo?.fields?.customFields)) {

                                        for (let f = 0; f < fetchInfo?.fields?.customFields.length; f++) {
                                            const customField = fetchInfo?.fields?.customFields[f];
                                            allFields.push(customField)

                                        }
                                    }


                                    let allChoosen = Array.isArray(fetchInfo?.fields?.choosen) ? JSON.parse(JSON.stringify(fetchInfo?.fields?.choosen)) : []

                                    if (fetchInfo.x_axis) {
                                        allChoosen.splice(0, 0, { value: fetchInfo.x_axis })
                                    }


                                    for (let f = 0; f < allChoosen.length; f++) {
                                        const choosen = allChoosen[f];

                                        for (let j = 0; j < allFields.length; j++) {
                                            let field = JSON.parse(JSON.stringify(allFields[j]))
                                            if (choosen.value == field.key) {
                                                if (choosen.config?.name) {
                                                    field.information.label = choosen.config?.name
                                                }

                                                if (field.type == 'FormulaInput' && field.config?.separateColumns) {
                                                    let columns = formulaColumnsParser.extractOutputLiteralsFromFormula(field.information?.formula)
                                                    if (columns.length > 0) {

                                                        for (let c = 0; c < columns.length; c++) {
                                                            const column = columns[c];
                                                            let key = `${field.key}|total_${column.replace(/\s+/g, "_")}`
                                                            let newField = { type: 'NumberInput', key, information: { label: column } }
                                                            // console.log("newField",newField)
                                                            fields.push(newField)

                                                        }
                                                    } else {
                                                        fields.push(field)
                                                    }
                                                } else {
                                                    fields.push(field)

                                                }
                                                break
                                            }

                                        }

                                    }


                                }

                                // console.log(fInfo)

                                fetchedData.push(fInfo)

                                let dataInfo = fetchResult.info
                                if (fetchInfo.api == 'getChartInfo') {

                                    let datasets = []
                                    let colField = fInfo.x_axis

                                    fetchResult.info.forEach((element, index) => {

                                        let newData = {}

                                        for (const [key, value] of Object.entries(element)) {

                                            if (key == '_id') {

                                                setObject(newData, colField, element._id?.col)

                                            } else {

                                                if (Array.isArray(fetchInfo.fields?.choosen)) {
                                                    for (let c = 0; c < fetchInfo.fields?.choosen.length; c++) {
                                                        const choosen = fetchInfo.fields?.choosen[c];

                                                        let splittedKey = key.split('|')
                                                        if (choosen.id == splittedKey[0]) {

                                                            // console.log('choosen', choosen, key, value)
                                                            let finalKey = choosen.value
                                                            if (splittedKey[1]) {
                                                                finalKey = `${finalKey}|${splittedKey[1]}`
                                                            }
                                                            setObject(newData, finalKey, value)

                                                        }
                                                    }
                                                }


                                            }

                                        }

                                        datasets.push(newData)

                                    })

                                    dataInfo = datasets
                                }

                                if (Array.isArray(dataInfo)) {
                                    dataInfo = dataInfo[0]
                                }
                                // console.log("HERE")
                                fullData[fetchInfo.name] = dataInfo

                                let param = { label: fetchInfo.name, value: fetchInfo.value, fields: fields, info: dataInfo, type: 'fetch' }

                                if (Array.isArray(param?.fields) && fetchInfo.api == 'getSingleRecord') {

                                    let foundId = false

                                    for (let a = 0; a < param?.fields.length; a++) {
                                        const element = param?.fields[a];
                                        if (element?.key == '_id') {
                                            foundId = true
                                        }
                                    }

                                    if (!foundId) {
                                        param?.fields.splice(0, 0, { key: '_id', type: 'TextInput', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID' } })
                                        param?.fields.push({ key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation date', } })
                                        param?.fields.push({ key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Update date', } })
                                    }
                                }

                                // console.log(param)
                                params.push(param)

                                // console.log(params)
                                resolve()

                            })
                        })

                    } else {


                        HttpServices.request('getFrame', { _id: fetchInfo.collection }, (fetchResult, fetchError) => {

                            if (fetchError) {
                                resolve()
                                return
                            }


                            // console.log(fetchResult)
                            let fInfo = fetchInfo
                            fInfo.info = {}//fetchResult.info
                            fInfo.frame = fetchResult

                            fetchedData.push(fInfo)


                            let param = { label: fetchInfo.name, value: fetchInfo.value, fields: fetchResult?.info?.fields, info: {}, type: 'fetch' }


                            if (Array.isArray(param?.fields)) {

                                let foundId = false

                                for (let a = 0; a < param?.fields.length; a++) {
                                    const element = param?.fields[a];
                                    if (element?.key == '_id') {
                                        foundId = true
                                    }
                                }

                                if (!foundId) {
                                    param?.fields.splice(0, 0, { key: '_id', type: 'TextInput', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID' } })
                                    param?.fields.push({ key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation date', } })
                                    param?.fields.push({ key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Update date', } })
                                }
                            }

                            params.push(param)

                            resolve()

                        })
                    }

                }))




            })



            Promise.all(promises).then(() => {

                // console.log(params)
                this.setState({ fetchedData, params, fullData, showPage: false }, () => {
                    this.setState({ showPage: true })
                })
            })

        } else {
            this.setState({ showPage: true })

        }


    }




    setData = (key, value, reference, cb) => {
        if (reference == 'PageBuilder') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    // topHeaderComponent = () => {
    //     return (
    //         <div className='flexc'>
    //             <div className='px-2'>
    //                 <PageBuilderAddElements type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} onDragStartAction={this.onDragStartAction} applet={this.props.applet} />
    //             </div>

    //             <ButtonAnimated
    //                 iconwidth='24px'
    //                 onClick={this.savePage}
    //                 title='Save'
    //                 icon='/assets/icons/plus-white.svg'
    //                 textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
    //                 invert={!this.props.colors?.iconInvert}
    //                 bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
    //             // border={''}
    //             />

    //         </div>
    //         // <button className='br-20 px-2 py-1' style={{backgroundColor:'#fff'}}>
    //         //     <p>Save</p>
    //         // </button>
    //     )
    // }
    // headerIdentityComponent = () => {
    //     return (
    //         <div className='' >
    //             <input onChange={(e) => this.setName(e.target.value)} value={this.state.name} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('insert name ...')} />
    //         </div>
    //         // <button className='br-20 px-2 py-1' style={{backgroundColor:'#fff'}}>
    //         //     <p>Save</p>
    //         // </button>
    //     )
    // }
    setName = (value) => {
        this.setState({ name: value })
    }

    // savePage = () => {
    //     console.log('savePag1', this.state.name)
    //     let content = this.PageBuilderMain.state.content

    //     if (!this.state.name) {
    //         // this.nameModal.showModal()
    //         return
    //     }

    //     let data = {
    //         _id: this.state._id,
    //         type: 'page',
    //         page: content,
    //         applet: this.props.variables.appletId
    //     }

    //     // console.log(data)
    //     this.setState({ data }, () => {
    //         console.log('page', this.props.page)
    //         let page = this.props.page


    //         let isEditing = data._id ? true : false
    //         let address = "postPage"//isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
    //         // data.page = this.props.page?.key
    //         this.setState({ isPostingData: true })

    //         if (page.postBody) {
    //             data = { ...data, ...page.postBody }
    //         }

    //         for (const [key, value] of Object.entries(data)) {
    //             if (/\{\{(.*?)\}\}/.test(value)) {

    //                 if (this.props.variables) {
    //                     data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //                 }
    //             }
    //         }
    //         // data.frame = this.state.currentFrame?._id
    //         // data.features = this.props.applet.features
    //         data.name = this.state.name
    //         console.log('address', address)
    //         console.log('data', data)
    //         HttpServices.request(address, data, (fetchResult, fetchError) => {
    //             if (fetchError) {
    //                 this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError.message })
    //                 return
    //             }
    //             // console.log([...this.props.baseUrl])


    //             let newLink = this.props.baseUrl.splice(2)
    //             newLink.push(fetchResult?.info?._id)
    //             // console.log(newLink)

    //             // this.props.changeWindowLink(newLink)
    //             this.setState({ _id: fetchResult?.info?._id })
    //             // console.log(fetchResult)
    //             this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })



    //         })
    //     })

    // }

    functionsHandler = (type, name, data, extra, cb) => {

        console.log("functionsHandler", type, name, data, extra)

        if (!type || type == 'frame' || type == 'collection') {
            if (this[name]) {
                this[name](data, extra, cb)
            } else {
                this.props.functionsHandler(type, name, data, extra, cb)
            }
        } else {
            this.props.functionsHandler(type, name, data, extra, cb)
        }
    }


    onDragStartAction = (e) => {
        this.PageBuilderMain.onDragStartAction(e)
    }

    render() {

        // let background = this.props.colors ? `linear-gradient(90deg, ${this.props.colors?.primaryColor}, ${this.props.colors?.secondaryColor})` : 'linear-gradient(to right, #5856D6, #7D7AFF)'


        return (
            <div className='w-100 d-flex window-content-radius h-100 ' >
                <div className='w-100 h-100'>
                    {/* <div className='w-100 posittion-sticky top-0'>
                        <PageBuilderHeader type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} getPage={this.getPage} />
                    </div> */}
                    {/* <div className='w-100 posittion-sticky top-0'>
                        <PageBuilderAddElements2 />
                    </div> */}
                    <div className='w-100 h-100'>
                        {this.state.showPage && (
                            <PageBuilderMain page={this.state.page} permissions={this.props.permissions} userView={this.props.userView} baseUrl={this.props.baseUrl} windowData={this.props.windowData} functionsHandler={this.functionsHandler} setHeader={this.props.setHeader} changeWindow={this.props.changeWindow} params={this.state.params} initData={this.state.initData} componentsInfoForm={this.state.componentsInfo['form']} type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} ref={el => this.PageBuilderMain = el} width={this.props.width} height={this.props.height} colors={this.props.colors ?? {}} changeWindowLink={this.props.changeWindowLink} pageChangePage={this.props.pageChangePage} applet={this.props.applet} editMode={false} addNewWindow={this.props.addNewWindow} padding={'0px'} name={this.state.name} showToolbar={this.props.showToolbar} variables={this.props.variables} />
                        )}
                        {/* <PageBuilderMain baseUrl={this.props.baseUrl} windowData={this.props.windowData} functionsHandler={this.props.functionsHandler} setHeader={this.props.setHeader} changeWindow={this.props.changeWindow} initData={this.state.initData} params={this.state.params} componentsInfoForm={this.state.componentsInfo['form']} type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} ref={el => this.PageBuilderMain = el} width={this.props.width} height={this.props.height} colors={this.props.colors} changeWindowLink={this.props.changeWindowLink} changePage={this.props.changePage} pageChangePage={this.props.pageChangePage} applet={this.props.applet} editMode={true} /> */}

                    </div>
                    {/* <div style={{ position: "fixed", bottom: "10px", left: "10px", zIndex: 10 }}>
                        <PageBuilderAddElements type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} onDragStartAction={this.onDragStartAction} />
                    </div> */}

                    {/* <Modal ref={el => this.nameModal = el} maxWidth={350}>
                        <div className='px-4 py-4 shadow-3 br-8 d-flex flex-column' style={{ backgroundColor: '#fff', }}>
                            <p className='text-semibold text-normal'>{translate("Please Insert a name for the page")}</p>
                            <p className='text-small'>{translate("So you can identify it later")}</p>

                            <div className='modern-input mt-3'>
                                <input className=' br-4 transpanet-input' onChange={(e) => this.setName(e.target.value)} placeholder={translate('Name ...')} />
                            </div>
                            <div className='flexcc mt-2 '>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={this.savePage}
                                    title='Save'
                                    icon='/assets/icons/plus-white.svg'
                                    textColor={this.props.colors?.textColor}
                                    invert={this.props.colors?.iconInvert}
                                    bg={background}
                                />

                            </div>
                        </div>
                    </Modal> */}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageViewer);